<template>
	<div class="site">
    <div slot="container">
      <div class="site.base-search">
        <el-input placeholder="请输入内容" v-model="paramsObj.keyword" class="input-with-select" @keyup.enter.native="search" clearable
        @clear="search" style="width:240px">
          <el-button slot="append" icon="el-icon-search" @click="search"></el-button>
        </el-input>
        <label>是否反馈:</label>
        <el-select style="width:140px" v-model="paramsObj.feedbackStatus" clearable placeholder="全部" @change="search">
          <el-option v-for="item in feedbackStatus" :key="item.value" :label="item.label" :value="item.value"></el-option>
        </el-select>
        <label>是否过期:</label>
        <el-select style="width:140px" v-model="paramsObj.expiredStatus" clearable placeholder="全部" @change="search">
          <el-option v-for="item in expiredStatus" :key="item.value" :label="item.label" :value="item.value"></el-option>
        </el-select>
        <label>是否标注:</label>
        <el-select style="width:140px" v-model="paramsObj.markStatus" clearable placeholder="全部" @change="search">
          <el-option v-for="item in markStatus" :key="item.value" :label="item.label" :value="item.value"></el-option>
        </el-select>
      </div>
      <div class="site.table">
        <el-table :data="tableData" stripe style="width: 100%" :header-cell-style="headerStyle">
					<el-table-column type="index" :index="(index) => {return index+ (paramsObj.page - 1) * paramsObj.pageSize + 1}" label="序号"
						align="center"></el-table-column>
					<el-table-column prop="investmentFirmsName" label="投资机构名称" align="center"></el-table-column>
          <el-table-column prop="enterprisesHistoryName" label="企业名称" align="center"></el-table-column>
          <el-table-column label="拟融资金额(万元)" align="center" prop="intendedFinancingAmount"></el-table-column>
          <el-table-column label="拟出让股权（%）" align="center" prop="imitateSellEquity"></el-table-column>
          <el-table-column label="融资用途" align="center" prop="financingPurpose"></el-table-column>
          <el-table-column prop="expiredStatus" label="是否过期" align="center">
            <template slot-scope="scope">
              <div>{{ scope.row.expiredStatus ? "已过期" : "未过期" }}</div>
            </template>
          </el-table-column>
          <el-table-column prop="feedbackStatus" label="是否反馈" align="center">
            <template slot-scope="scope">
              <div>{{ scope.row.feedbackStatus ? "已反馈" : "未反馈" }}</div>
            </template>
          </el-table-column>
          <el-table-column prop="institutionsApprovalStatus" label="审核状态" align="center">
            <template slot-scope="scope">
              <div v-if="scope.row.institutionsApprovalStatus === 1">待审核</div>
              <div v-if="scope.row.institutionsApprovalStatus === 2">不通过</div>
              <div v-if="scope.row.institutionsApprovalStatus === 3">退回</div>
              <div v-if="scope.row.institutionsApprovalStatus === 4">通过</div>
            </template>
          </el-table-column>
          <el-table-column prop="markStatus" label="是否标注" align="center">
            <template slot-scope="scope">
              <div>{{ scope.row.markStatus ? "已标注" : "未标注" }}</div>
            </template>
          </el-table-column>
          <el-table-column label="操作" align="center">
            <template slot-scope="scope">
							<el-button class="mini_btn" type="text" size="mini" @click="handleDetail(scope.row, true)">详情</el-button>
							<el-button style="margin-bottom: 5px;" size="mini" @click="openSiteModal(scope.row, false)" v-if="scope.row.institutionsApprovalStatus === 1 && isInvest && !scope.row.expiredStatus">编辑</el-button>
            </template>
          </el-table-column>
        </el-table>
        <!-- 分页 -->
        <div class="pagination">
          <div class="grid-content bg-purple-light">
						<el-pagination @current-change="handleCurrentChange" :hide-on-single-page="true" layout="total, prev, pager, next,jumper"
							:total="total" :current-page.sync="paramsObj.page" :page-size="paramsObj.pageSize"></el-pagination>
          </div>
        </div>
      </div>
    </div>

		<!-- 新增机构 -->
		<el-dialog :title="titleDialog" :visible.sync="dialogFormVisible"
		 :close-on-click-modal="false" @closed="is_submit = true" :append-to-body="true" :modal-append-to-body="true" class="site.dialog">
		 	<el-form :model="ruleForm" ref="ruleForm" :rules="rules" label-width="140px">
				<div class="form-title">投资需求</div>
        <el-row>
          <el-row>
            <el-form-item label="企业名称" prop="enterprisesHistoryName">
              <el-input v-model="ruleForm.enterprisesHistoryName" placeholder="请输入企业名称" disabled></el-input>
            </el-form-item>
          </el-row>
          <el-row>
            <el-form-item label="意向金融机构" prop="investmentFirmsName">
              <el-input v-model="ruleForm.investmentFirmsName" placeholder="请输入意向金融机构" disabled></el-input>
            </el-form-item>
          </el-row>
          <el-row>
            <el-form-item label="拟出让股权（%）" prop="imitateSellEquity">
              <el-input v-model="ruleForm.imitateSellEquity" type="number" placeholder="请输入拟出让股权（%）" disabled></el-input>
            </el-form-item>
          </el-row>
          <el-row>
            <el-form-item label="拟融资金额（万元）" prop="intendedFinancingAmount">
              <el-input v-model="ruleForm.intendedFinancingAmount" type="number" placeholder="请输入拟融资金额" disabled></el-input>
            </el-form-item>
          </el-row>
          <el-row>
            <el-form-item label="融资用途" prop="financingPurpose">
              <el-input
                type="textarea"
                :autosize="{ minRows: 2, maxRows: 4 }"
                placeholder="请输入融资用途"
                v-model="ruleForm.financingPurpose"
								disabled
              ></el-input>
            </el-form-item>
          </el-row>

          <!-- 企业信息开始 -->
					<div class="form-title">企业信息</div>
          <el-row :span="20">
            <el-col :span="12">
              <el-form-item label="企业名称" prop="enterpriseName">
                <el-input v-model="ruleForm.enterpriseName" placeholder="请输入企业名称" disabled></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="组织机构代码" prop="organizationCode">
                <el-input v-model="ruleForm.organizationCode" placeholder="请输入组织机构代码" disabled></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :span="20">
            <el-col :span="12">
              <el-form-item label="企业法人" prop="legalPerson">
                <el-input v-model="ruleForm.legalPerson" placeholder="请输入企业法人" disabled></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="联系方式" prop="legalPersonPhone">
                <el-input v-model="ruleForm.legalPersonPhone" placeholder="请输入联系方式" disabled></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :span="20">
            <el-col :span="12">
              <el-form-item label="财务负责人" prop="financialLeader">
                <el-input v-model="ruleForm.financialLeader" placeholder="请输入财务负责人" disabled></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="联系方式" prop="financialLeaderPhone">
                <el-input v-model="ruleForm.financialLeaderPhone" placeholder="请输入联系方式" disabled></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :span="20">
            <el-col :span="12">
              <el-form-item label="联系人" prop="contactPerson">
                <el-input v-model="ruleForm.contactPerson" placeholder="请输入联系人" disabled></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="联系方式" prop="contactPersonPhone">
                <el-input v-model="ruleForm.contactPersonPhone" placeholder="请输入联系方式" disabled></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :span="20">
            <el-col :span="12">
              <el-form-item label="成立时间" prop="establishDate">
                <el-date-picker
                  style="width: 100%"
                  v-model="ruleForm.establishDate"
                  format="yyyy-MM-dd"
                  value-format="yyyy-MM-dd"
                  type="date"
                  placeholder="选择成立时间"
									disabled
                ></el-date-picker>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="纳税地点" prop="taxLocation">
                <el-input v-model="ruleForm.taxLocation" placeholder="请输入纳税地点" disabled></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :span="20">
            <el-col :span="24">
              <el-form-item label="注册地址" prop="registeredAddress">
                <v-distpicker
                  style="text-align:left;"
                  @selected="citySelected"
                  :province="registeredAddress[0]"
                  :city="registeredAddress[1]"
                  :area="registeredAddress[2]"
									disabled
                ></v-distpicker>
              </el-form-item>
              <el-form-item prop="registeredAddressDetail">
                <el-input v-model="ruleForm.registeredAddressDetail" placeholder="请填写详细地址" disabled></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :span="20">
            <el-col :span="24">
              <el-form-item label="实际地址" prop="physicalAddress">
                <v-distpicker
                  style="text-align:left;"
                  @selected="citySelected"
                  :province="physicalAddress[0]"
                  :city="physicalAddress[1]"
                  :area="physicalAddress[2]"
									disabled
                ></v-distpicker>
              </el-form-item>
              <el-form-item prop="physicalAddressDetail">
                <el-input v-model="ruleForm.physicalAddressDetail" placeholder="请填写详细地址" disabled></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :span="20">
            <el-col :span="24">
              <el-form-item label="主要经营产品" prop="mainProduct">
                <el-input v-model="ruleForm.mainProduct" placeholder="请填写主要经营产品" disabled></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :span="20">
            <el-col :span="12">
              <el-form-item label="上年度末总资产" prop="lastYearTotalAssets">
                <el-input v-model="ruleForm.lastYearTotalAssets" placeholder="请填写主要经营产品" disabled></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="上年度销售收入" prop="lastYearSalesRevenue">
                <el-input v-model="ruleForm.lastYearSalesRevenue" placeholder="请填写主要经营产品" disabled></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :span="20">
            <el-col :span="24">
              <el-form-item label="自主知识产权数量" prop="independentRightCount">
                <el-input v-model="ruleForm.independentRightCount" placeholder="请填写自主知识产权数量" disabled></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="20">
            <el-col :span="24">
              <el-form-item label="公司简介" prop="introduction">
                <el-input
                    type="textarea"
                    :autosize="{ minRows: 4, maxRows: 6 }"
                    placeholder=" 请填写公司简介"
                    v-model="ruleForm.introduction"
                    disabled
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>

          <!-- 反馈记录列表开始 -->
					<div class="form-title">
            反馈记录
            <el-button style="cursor: pointer;font-size: 12px;color: #169BD5;border: none;" @click="addFeekback">+添加反馈</el-button>
          </div>
          <el-table
            :data="tableFeekback"
            style="width: 100%"
            :header-cell-style="{ background: '#E5F3FE', color: '#623AA2' }"
            class="table"
          >
            <el-table-column type="index" width="80" label="序号" align="center"></el-table-column>
            <el-table-column label="留言" align="center" prop="content"></el-table-column>
            <el-table-column label="反馈时间" align="center" prop="createTime"></el-table-column>
						<el-table-column label="操作" align="center">
							<template slot-scope="scope">
								<el-button style="margin-bottom: 5px;" size="mini" @click="deleteFeekback(scope.row)">删除</el-button>
							</template>
						</el-table-column>
          </el-table>


          <div class="form-title">审核信息</div>
          <!-- 审核信息开始 -->
          <el-row :span="20">
            <el-col :span="12">
              <el-form-item label="审核状态" prop="approvalStatus">
                <el-select v-model="ruleForm.approvalStatus" placeholder="请选择审核状态" :disabled="disabled" @change="statusChange">
                  <el-option label="待审核" :value="1"></el-option>
                  <el-option label="不通过" :value="2"></el-option>
                  <el-option label="退回" :value="3"></el-option>
                  <el-option label="通过" :value="4"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="审核意见" prop="auditOpinion">
                <el-input v-model="ruleForm.auditOpinion" placeholder="请填写审核意见" :disabled="disabled"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :span="20">
            <el-col :span="24">
              <el-form-item label="附件上传" prop="fileList">
                <el-upload class="upload-demo" :action="this.uploadURL" style="text-align: left;" :before-upload="beforeAvatarUpload" :disabled="disabled"
								:on-remove="(file, fileList)=>handleRemove(file, fileList,'fileList')" :file-list="fileList" :on-success="(response, file, fileList) => handleAvatarSuccess(response, file, fileList,'fileList')"
								list-type="picture">
									<el-button size="small" type="primary" :disabled="disabled">上传附件材料</el-button>
								</el-upload>
              </el-form-item>
            </el-col>
          </el-row>

          <!-- 标注信息开始 -->
          <div class="form-title" v-if="ruleForm.approvalStatus === 4">标注信息</div>
          <el-row v-if="ruleForm.approvalStatus === 4">
            <el-col :span="12">
              <el-form-item label="投资金额（万元）" prop="investmentAmount">
                <el-input v-model="ruleForm.investmentAmount" type="number" placeholder="请填写投资金额" :disabled="disabled"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="股权占比（%）" prop="equityRatio">
                <el-input v-model="ruleForm.equityRatio" type="number" placeholder="请填写股权占比" :disabled="disabled"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
				</el-row>
      </el-form>
			<div slot="footer" class="dialog-footer">
				<el-button @click="dialogFormVisible = false">取 消</el-button>
				<el-button type="primary" @click="createSite" v-if="!disabled">确 定</el-button>
			</div>
		</el-dialog>

		<!-- 添加反馈 -->
		<el-dialog title="添加反馈" :visible.sync="addFeekbackDialog" :append-to-body="true" :modal-append-to-body="true">
			<el-form :model="feekbackForm" :rules="feekbackRules" ref="feekbackForm" label-width="60px">
				<el-form-item label="留言:" prop="content">
					<el-input v-model="feekbackForm.content"></el-input>
				</el-form-item>
			</el-form>
			<div slot="footer" class="dialog-footer">
				<el-button @click="addFeekbackDialog = false">取 消</el-button>
				<el-button type="primary" @click="confirmFeekback">确 定</el-button>
			</div>
		</el-dialog>
	</div>
</template>
<script>
	import InputNumberRange from "../../../components/inputNumberRange"
	export default {
		components: {
			InputNumberRange
		},
		data() {
			return {
				disabled: false,
				feekbackForm: {
					needsApplyId: 0,
					content: ""
				},
				feekbackRules: {
					content: [
						{ required: true, message: "请输入留言", trigger: "blur" }
					]
				},
				needsApplyId: 0, //	融资需求id
				tableFeekback: [],
				financingTermList: [],
				guaranteeTypeList: [],
				feedbackStatus: [
					{ value: 0, label: "未反馈" },
					{ value: 1, label: "已反馈" }
				], // 是否反馈
				expiredStatus: [
					{ value: 0, label: "未过期" },
					{ value: 1, label: "已过期" }
				], // 是否过期
				markStatus: [
					{ value: 0, label: "未标注" },
					{ value: 1, label: "已标注" }
				], // 是否标注
				titleDialog: "",
				listUrl: `${urlConfig.devUrl}apij2/admin-api/finance/needs-apply/approval/page`,
				fieldValue: "",
				levelOptions: [],
				financeRange: [], // 融资额度数组
				numberRange: [],
				productSuitableArr: [], // 覆盖地域
				is_submit: true,
				headerStyle: {
					color: "#623AA2",
					background: "#E5F3FE",
				},
				fileList: [],
				paramsObj: {
					keyword: "",
					page: 1,
					pageSize: 10,
					feedbackStatus: "",
					expiredStatus: "",
					markStatus: "",
					financingType: 2
				},
				feedbackObj: {
					needsApplyId: 0,
					page: 1,
					pageSize: 1000
				},
				operationType: "add",
				total: 20,
				dialogFormVisible: false,
				registeredAddress: [],
				physicalAddress: [],
				ruleForm: {
					enterprisesHistoryId: '', // 企业快照id
					enterprisesHistoryName	: '', // 企业快照名称
					investmentFirmsId: '', // 意向金融/投资机构id
					investmentFirmsName: '', // 意向金融/投资机构名称
          imitateSellEquity: "", // 拟出让股权
					intendedFinancingAmount: '', // 拟融资金额
					financingPurpose: '', // 融资用途

					investmentAmount: "", // 投资机构-标注-投资金额(万元)
					equityRatio: "", // 投资机构-标注-股权占比
					guaranteeStatus: "", // 担保状态: 5未担保, 6拒绝担保, 7已担保, 8无需担保
					enterpriseName: "", // 企业名称
					organizationCode: "", // 组织机构代码
					legalPerson: "", // 企业法人
					legalPersonPhone: "", // 企业法人联系方式
					financialLeader: "", // 财务负责人
					financialLeaderPhone: "", // 财务负责人联系方式
					contactPerson: "", // 联系人
					contactPersonPhone: "", // 联系方式
					establishDate: "", // 成立时间
					taxLocation: "", // 纳税地点
					mainProduct: "", // 主要经营产品
					lastYearTotalAssets: "", // 上年度末总资产
					lastYearSalesRevenue: "", // 上年度销售收入
					registeredAddress: "", // 注册地址json
					registeredAddressDetail: "", // 注册地详细地址
					physicalAddress: "", // 实际地址json
					physicalAddressDetail: "", // 实际地址详细地址
					auditOpinion: "", // 审核意见
					fileList: "", // 附件
					approvalStatus: 1, // 审核状态: 1待审核, 2不通过 3退回, 4通过,
				},
				rules: {
					approvalStatus: [
						{ required: true, message: "请选择审批状态", trigger: ["blur", "change"] }
					],
				},
				tableData: [],
        image: "",
				addFeekbackDialog: false, // 添加反馈
			};
		},
		methods: {
			statusChange(e) {
				if(e === 4) {
					this.rules = {
						investmentAmount: [
							{ required: true, message: "请输入投资金额", trigger: ["blur", "change"] }
						],
						equityRatio: [
							{ required: true, message: "请输入股权占比", trigger: ["blur", "change"] }
						],
						approvalStatus: [
							{ required: true, message: "请选择审批状态", trigger: ["blur", "change"] }
						],
					}
				}else{
					this.rules = {}
				}
			},

			// 添加反馈
			addFeekback() {
				this.addFeekbackDialog = true
			},
			confirmFeekback() {
				this.feekbackForm.needsApplyId = this.needsApplyId
				this.$refs["feekbackForm"].validate((valid) => {
					if (valid) {
						this.http.post(`${urlConfig.devUrl}apij2/admin-api/finance/feedback-record/create`, this.feekbackForm).then(
							(response) => {
								if (response.code == 0) {
									console.log('response', response)
									this.$message.success("添加反馈成功")
									this.getFeedback()
									this.addFeekbackDialog = false
									this.feekbackForm.content = ""
								} else {
									this.$message.error(response.status);
								}
							},
							(error) => {}
						);
					}else{
						return false
					}
				})
			},
			// 获取数据字典
			getGroup(row) {
				let obj = {
					dictTypes: ["financial_financing_term", "corporate_financing_protection_method"]
				}
				this.http.post(`${urlConfig.devUrl}apij2/admin-api/system/dict-data/getGroup`, obj).then(
					(response) => {
						if (response.code == 0) {
							console.log('response', response)
							this.financingTermList = response.data.financial_financing_term
							this.guaranteeTypeList = response.data.corporate_financing_protection_method

							// this.ruleForm = response.data
						} else {
							this.$message.error(response.status);
						}
					},
					(error) => {}
				);
			},
			radioChange(e) {
				console.log(e)
			},
      beforeAvatarUpload(file) {
        const isLt2M = file.size / 1024 / 1024 < 10;
        if (!isLt2M) {
          this.$message.error("上传图片大小不能超过 10MB!");
        }
        return isLt2M;
      },
			handleRemove(file, fileList, type) {
				this.fileList = fileList
				if(fileList.length === 0) {
					this.ruleForm.fileList = ""
				}else{
					this.ruleForm.fileList = JSON.stringify(fileList)
				}
			},
			handleAvatarSuccess(response, file, fileList, type) {
				if (response.code == 0) {
					this.fileList = fileList

					this.fileListChange(type);
				}
			},
			fileListChange(type) {
				let arr = [];
				if (this[type].length > 0) {
					this[type].map(item => {
						arr.push({
							url: item.size ? this.imgUrl + item.response.data.store_result : item.url,
							name: item.name
						});
					});
					this.ruleForm[type] = JSON.stringify(arr);

					// if (type === 'logoSrc' || type === 'realImageSrc') {
					//   this.ruleForm[type] = arr[0].url;
					// }
				} else {
					this.ruleForm[type] = '';
					this[type] = [];
				}
			},
			//城市选择
			citySelected(e) {
				this.ruleForm.address = e;
			},
			inputfrom(val) {
				this.numberRange[0] = val
			},
			inputto(val) {
				this.numberRange[1] = val
			},
			inputFinancefrom(val) {
				this.financeRange[0] = val
			},
			inputFinanceto(val) {
				this.financeRange[1] = val
			},
			selectChange(e, list, props) {
				if(e) {
					this.ruleForm[props] = list.find(item => item.value === e).label
				}else{
					this.ruleForm[props] = ""
				}
				console.log("this.ruleForm[props]", this.ruleForm[props])
			},
			// 确认添加机构
			createSite() {
				if (!this.is_submit) {
					return;
				}
				this.is_submit = false;
				this.$refs["ruleForm"].validate((valid) => {
					if (valid) {
						this.ruleForm.needsApplyId = this.needsApplyId
						this.http
						.post(`${urlConfig.devUrl}apij2/admin-api/finance/needs-apply-record/approval`, this.ruleForm)
							.then((res) => {
								if (res.code == 0) {
									this.$message.success("编辑成功！");
									this.getData();
									this.dialogFormVisible = false;
									this.resetForm()
									this.registeredAddress = []
									this.physicalAddress = []
									this.fileList = []
								} else {
									this.is_submit = true;
									this.$message.error(res.status);
								}
							}).catch(err => {
								this.is_submit = true;
							});
					} else {
						this.is_submit = true;

						console.log("error submit!!");
						return false;
					}
				});
			},
			// 新增
			openSiteModal(row) {
				if(row.institutionsApprovalStatus !== 1) {
					this.disabled = true
				}else{
					this.disabled = false
				}
				this.needsApplyId = row.id
				this.operationType = row ? "edit" : "add";
				this.dialogFormVisible = true;
				this.resetForm();

				if(this.operationType === "edit") {
					this.titleDialog = "编辑需求"
					this.getDetail(row)
					this.getFeedback(row)
				}
			},
			getFeedback(row) {
				this.feedbackObj.needsApplyId = this.needsApplyId
				this.http.post(`${urlConfig.devUrl}apij2/admin-api/finance/feedback-record/page`, this.feedbackObj).then(
					(response) => {

						if (response.code == 0) {
							console.log('response', response)
							this.tableFeekback = response.data.data
						} else {
							this.$message.error(response.status);
						}
					},
					(error) => {}
				);
			},
			// 删除反馈
			deleteFeekback(row) {
				this.$confirm("确定删除该条反馈吗?", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
          center: true,
        })
          .then(() => {
						this.confirmDeleteFeekback(row)
          })
          .catch(() => {
            this.$message({
              type: "info",
              message: "已取消删除",
            });
          });
			},
			confirmDeleteFeekback(row) {
				let obj = {
					ids: [row.id]
				}
				this.http.delete(`${urlConfig.devUrl}apij2/admin-api/finance/feedback-record/delete`, obj).then(
					(response) => {
						if (response.code == 0) {
							console.log('response', response)
							this.$message({
								type: "success",
								message: "删除成功!",
							});
							this.getFeedback()
						} else {
							this.$message.error(response.status);
						}
					},
					(error) => {}
				);
			},
			// 详情
			handleDetail(row) {
				this.needsApplyId = row.id
				this.titleDialog = "需求详情"
				this.operationType = "detail";
				this.getDetail(row)
				this.getFeedback(row)
				this.disabled = true
				this.dialogFormVisible = true;
			},

			// 获取金融产品详情
			getDetail(row) {
				this.http.get(`${urlConfig.devUrl}apij2/admin-api/finance/needs-apply/getDetail?id=${row.id}`).then(
					(response) => {

						if (response.code == 0) {
							console.log('response', response)
							this.ruleForm = response.data
							this.registeredAddress = response.data.registeredAddress ? JSON.parse(response.data.registeredAddress) :[]
							this.physicalAddress = response.data.physicalAddress ? JSON.parse(response.data.physicalAddress) : []
							this.fileList = response.data.fileList ? JSON.parse(response.data.fileList) : []

							this.statusChange(response.data.approvalStatus)
						} else {
							this.$message.error(response.status);
						}
					},
					(error) => {}
				);
			},
			resetForm() {
				this.ruleForm = {
					financingType: '', // 融资方式: 1债权融资, 2股权融资
					enterprisesHistoryId: '', // 企业快照id
					enterprisesHistoryName	: '', // 企业快照名称
					investmentFirmsId: '', // 意向金融/投资机构id
					investmentFirmsName: '', // 意向金融/投资机构名称
					intendedFinancingAmount: '', // 拟融资金额
					financingPurpose: '', // 融资用途
					financingTermId: '', // 金融机构-融资期限
					financingTermName: '', // 金融机构-融资期限名称
					guaranteeTypeId: '', // 金融机构-可提供担保方式:
					guaranteeTypeName: '', // 金融机构-可提供担保类型名称
					guaranteeInstitutionState: '', // 金融机构-担保机构: 0不需要, 1需要
					guaranteeInstitutionId: "", // 金融机构-担保机构id
					guaranteeInstitutionName: "", // 金融机构-担保机构名称
					markProductTypeId: "", // 金融机构-标注-产品类型:待定
					markProductTypeName: "", // 金融机构-标注-产品类型名称:待定
					markFinancingAmount: "", // 金融机构-标注-融资金额
					markGuaranteeTypeId: "", // 金融机构-标注-担保类型:
					markGuaranteeTypeName	: "", // 金融机构-标注-担保类型名称
					imitateSellEquity: "",  // 投资机构-拟出让股权
					equityRatio: "", // 投资机构-标注-股权占比
					guaranteeStatus: "", // 担保状态: 5未担保, 6拒绝担保, 7已担保, 8无需担保
					enterpriseName: "", // 企业名称
					organizationCode: "", // 组织机构代码
					legalPerson: "", // 企业法人
					legalPersonPhone: "", // 企业法人联系方式
					financialLeader: "", // 财务负责人
					financialLeaderPhone: "", // 财务负责人联系方式
					contactPerson: "", // 联系人
					contactPersonPhone: "", // 联系方式
					establishDate: "", // 成立时间
					taxLocation: "", // 纳税地点
					mainProduct: "", // 主要经营产品
					lastYearTotalAssets: "", // 上年度末总资产
					lastYearSalesRevenue: "", // 上年度销售收入
					registeredAddress: "", // 注册地址json
					registeredAddressDetail: "", // 注册地详细地址
					physicalAddress: "", // 实际地址json
					physicalAddressDetail: "", // 实际地址详细地址
					auditOpinion: "", // 审核意见
					fileList: "", // 附件
					approvalStatus: 1, // 审核状态: 1待审核, 2不通过 3退回, 4通过,
				}
			},
			//选择页码
			handleCurrentChange(e) {
				this.paramsObj.page = e;
				this.getData();
			},
			//搜索
			search() {
				this.getData();
			},
			getData() {
				this.http.post(this.listUrl, this.paramsObj).then((res) => {
					if (res.code == 0) {
						this.tableData = res.data.data;
						this.total = res.data.total;
					}
				});
			},
		},
		mounted() {
			this.getData();
			this.getGroup()
		},
	};
</script>
<style lang="scss">
	@include component(site) {
		width: 100%;
		height: 100%;

		@include part(header) {
			display: flex;
			justify-content: flex-start;

			@include component(el-input) {
				width: 300px;
			}
		}
			.el-select {
				margin: 0 15px;
			}

			@include part(base-search){
				width: 100%;
			text-align: left;
			display: flex;
			flex-wrap: wrap;
			justify-content: flex-start;
			align-items: center;

			label{
				margin-left: 20px;
			}

			/deep/.el-input--suffix {
				width: 100%;
			}

			.el-input {
				margin: 0 15px;
			}

			.date-picker {
				margin: 0 15px;

				.el-range-separator {
					width: auto;
				}
			}
			}
    // .base-search {

		// }

		@include part(searchBtn) {
			margin-left: 10px;
		}

		@include part(addBtn) {
			margin-right: 30px !important;
			background: #623aa2 !important;
			color: #fff;
			border: none;
		}

		@include part(table) {
			margin-top: 30px;
		}

		@include component(rowItem) {
			width: 50%;
		}

		@include component(el-radio-group) {
			width: 100%;
			text-align: left;
		}
		@include part(dialog) {
		.avatar-uploader .el-upload {
			border: 1px dashed #d9d9d9;
			border-radius: 6px;
			cursor: pointer;
			position: relative;
			overflow: hidden;
		}

		.avatar-uploader .el-upload:hover {
			border-color: #409eff;
		}

		.avatar-uploader-icon {
			font-size: 28px;
			color: #8c939d;
			width: 178px;
			height: 130px;
			line-height: 130px;
			text-align: center;
		}

		.avatar {
			width: 178px;
			height: 178px;
			display: block;
		}

		.el-radio-group {
			display: flex;
			height: 40px;
		}
		.el-select{
				width: 100%;
			}
		.upload_btn {
			display: block;
			background-color: #00a1ff;
			font-weight: bold;
			color: #fff;
			padding: 2px;
			border-bottom-left-radius: 3px;
			border-bottom-right-radius: 3px;
		}

		.el-radio {
			display: flex;
			align-items: center;
		}

		.imgInput {
			background: url(../../../assets/add.png) no-repeat;
			border: none;
			text-indent: -2000px;
			height: 120px;
			padding: 10px;
			background-size: 70%;
			background-position: center;
			color: white;
			cursor: pointer;
		}

		.imgInput:focus {
			border: none;
			outline: 0;
		}

		.allPics {
			border: 1px solid #ccc;
			padding: 18px 15px 10px 20px;
			width: 90%;
			margin: 0 auto;
			margin-bottom: 30px;
			position: relative;
			// display: flex;
			// flex-wrap: wrap;
			// justify-content: space-between;
		}

		.allPics1 {
			display: flex;
			// flex-wrap: wrap;
		}

		.addPic-body {
			padding: 10px;
			height: 120px;
		}

		.addPic-close {
			position: absolute;
			top: 10px;
			right: 10px;
		}

		.addPic {
			max-width: 100%;
			max-height: 100%;
		}

		.el-form-item__content {
			text-align: left;
		}

		.form-title {
			width: 100%;
			text-align: left;
			color: #623aa2;
			border-left: 5px solid #623aa2;
			border-bottom: 1px solid #623aa2;
			padding-left: 10px;
			font-size: 20px;
			margin-bottom: 20px;
			font-weight: 700;
		}
	}

		.rowItem1 {
			float: left;
		}
	}
</style>
